import { Navigate, Outlet, useMatches } from 'react-router'
import { z } from 'zod'
import { useAuthStore } from '@/features/auth/store/store.ts'
import { useParsedSearchParams } from '@/hooks/use-parsed-search-params'
import { routes } from '@/routes'

interface RouteHandle {
	redirectTo?: string
}

const SearchParams = z.object({
	redirect_to: z.string().optional()
})

export const PublicRoute = () => {
	const accessToken = useAuthStore((state) => state.accessToken)
	const { searchParams } = useParsedSearchParams(SearchParams)
	const matches = useMatches()

	if (!accessToken) {
		return <Outlet />
	}

	const currentRoute = matches.at(-1)
	const customRedirect = (currentRoute?.handle as RouteHandle)?.redirectTo

	const redirectPath =
		searchParams.redirect_to ?? customRedirect ?? routes.WELCOME.path
	return <Navigate replace to={redirectPath} />
}
